import { Button, Card, Form, Input } from "antd";
import React, { FC } from "react";

interface IProps {}

/**
 * @author
 * @function @
 **/

export const AddRemarks = (props) => {
  return (
    <Card>
      <Form form={props?.form} layout="vertical">
        <Form.Item label="Remarks" name="remarks">
          <Input.TextArea rows={3} placeholder="Enter remarks..." />
        </Form.Item>
      </Form>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "30px",
        }}
      >
        <Button onClick={() => props?.onToggle(false)} type="default" size="large" className="csv_publish">
          Back
        </Button>
        <Button
          htmlType="button"
          onClick={() => props?.submitData()}
          type="primary"
          size="large"
          className="csv_publish"
        >
          {"Submit"}
        </Button>
      </div>
    </Card>
  );
};
